import { Card, Table } from "react-bootstrap";
import { TemperaturInfoByggnad, TemperaturInfoStickprov } from "../../../types/ModuleDatas";

interface IProps {
  tempInfo: TemperaturInfoByggnad;
  stickprov: TemperaturInfoStickprov;
}

const TemperaturInfo = ({ tempInfo, stickprov }: IProps) => {
  return tempInfo && stickprov ? (
    <Card className="mb-3">
      <Card.Header>Info temperaturer</Card.Header>
      <div className="row">
        <div className="col-lg-6 col-xxl-6">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>{tempInfo.verksamhet}</th>
                <th>°C</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Uppmätt medeltemperatur</td>
                <td>{new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 1 }).format(tempInfo.uppmättMedeltemperatur)}</td>
              </tr>
              <tr>
                <td>Rekommenderad medeltemperatur</td>
                <td>{tempInfo.rekommenderadMedelTemperatur}</td>
              </tr>
              <tr>
                <td>Avvikelse medeltemperatur </td>
                <td>{new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 1 }).format(tempInfo.diffUppmättMotRekommenderat)}</td>
              </tr>
              <tr>
                <td>Temperaturspann i lokaler ∆t (Högst-Lägst)</td>
                <td>{new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 1 }).format(tempInfo.uppmättTempDiff)}</td>
              </tr>
            </tbody>
          </Table>
        </div>
        {/* <div className="col-xxl-1 d-none d-xxl-block ps-0 pe-0"></div> */}
        <div className="col-lg-6 col-xxl-6  ">
          <Table bordered hover className="table-data">
            <thead>
              <tr>
                <th colSpan={3}>Stickprovsmätningar</th>
              </tr>
              <tr>
                <th style={{ fontWeight: "normal", paddingLeft: "20px" }} colSpan={3}>
                  Temperatur i lokaler för betjänande shuntgrupp.
                </th>
              </tr>
              <tr>
                <th>Högst °C</th>
                <th>Lägst °C</th>
                <th>Medel °C</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 1 }).format(stickprov.HögstUppmätt)}</td>
                <td>{new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 1 }).format(stickprov.LägstUppmätt)}</td>
                <td>{new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 1 }).format(stickprov.MedelUppmätt)}</td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
    </Card>
  ) : (
    <></>
  );
};

export default TemperaturInfo;
